import React, { useState } from 'react';
import { Button, Col, Row } from 'react-bootstrap';
import columns from './Columns';
import CompanyDataTableDt from './CompanyDataTableDt';

const CompanyIndex = () => {
  const [moreData, setMoreData] = useState(false);
  const [activeTab, setActiveTab] = useState('active');

  const activeCompanies = activeTab === 'active';

  return (
    <>
      <Row className="mt-4 mb-1">
        <Col>
          <h2 className="h2-dt mt-3">Empresas Vigentes / No Vigentes</h2>
        </Col>
      </Row>
      <Row className="mb-2">
        <Col sm={12} md={2} lg={3} className="pr-md-1 mb-1 mt-2">
          <Button
            variant={`${activeCompanies ? 'primary' : 'outline-primary'}`}
            className={`toogle ${activeCompanies ? 'active' : ''} mb-1 mt-2`}
            block
            onClick={() => setActiveTab('active')}
            size="sm"
            style={{ color: `${activeCompanies ? '#fff' : '#000'}` }}
          >
            Vigentes
          </Button>
        </Col>
        <Col sm={12} md={2} lg={3} className="pl-md-1 mb-1 mt-2">
          <Button
            variant={`${!activeCompanies ? 'primary' : 'outline-primary'}`}
            className={`toogle ${!activeCompanies ? 'active' : ''} mb-1 mt-2`}
            block
            onClick={() => setActiveTab('inactive')}
            size="sm"
            style={{ color: `${!activeCompanies ? '#fff' : '#000'}` }}
          >
            No Vigentes
          </Button>
        </Col>
      </Row>
      <CompanyDataTableDt
        key={activeTab}
        moreData={moreData}
        setMoreData={setMoreData}
        columns={columns}
        activeCompanies={activeCompanies}
      />
    </>
  );
};
export default CompanyIndex;
